import {
   SEARCH_PURCHASES_URL
} from 'app/utils/Constants';

import {
  post
} from 'app/services/ApiService';

export const getPurchases = async params => {
  return await post(SEARCH_PURCHASES_URL(), params);
}
